/** User acknowledged essential cookies / local storage (Supabase session, preferences). */
export const COOKIE_CONSENT_STORAGE_KEY = 'p2t_cookie_consent_v1';

/** User accepted that prompts are sent to third-party AI APIs for workout generation. */
export const AI_PROCESSING_CONSENT_STORAGE_KEY = 'p2t_ai_processing_consent_v1';
